/* eslint-disable max-len */
/**
* @file 战队-公约指南
* @author 余凯
*/

import React from 'react'
import { Tabs } from 'antd'
import './index.less'
import { connect } from 'react-redux'

import Medal1000 from '../../img/1000.png'
import Medal1001 from '../../img/1001.png'
import Medal1002 from '../../img/1002.png'
import Medal1003 from '../../img/1003.png'
import Medal1004 from '../../img/1004.png'
import Medal1005 from '../../img/1005.png'
import Medal1006 from '../../img/1006.png'

const { TabPane } = Tabs

const columns = [
  {
    title: '名次',
    dataIndex: 'name',
    width: 150,
  },
  {
    title: 'Age',
    dataIndex: 'age',
    width: 150,
  },
  {
    title: 'Address',
    dataIndex: 'address',
  },
];

@connect(
  state => state.teamReducer,

)
class Guide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      own: 0
    }
  }

  render() {
    return (
      <div className="guide" id="guide">

        <Tabs animated type="card">
          <TabPane tab="公约指南" key="1">
            <div className="content_rules">
              {/* <div className="rules_title">
                    战队公约
              </div> */}
              <div >
                K7战队是K7游戏为K7用户推出的一项新的服务，为了更好的服务广大K7用户，特制定此公约。
              </div>
              <div>
                《K7战队公约》是K7游戏制定的，维护k7用户和k7公会的正当权益，协调各公会之间关系的行为准则。以下为此公约主要内容：
              </div>
              <div>
                1.K7公会名称和公会图标的选择必须符合国家的有关法律法规以及K7游戏平台的相关规定。公会名称不可以使用国家党政军机关的名称和编制、国家企事业单位的名称和编制、一切国家明令禁止使用的名称，一切不符合文明习惯、亵渎人文文化、有损民族形象的名称。如果使用的名称违反了上述规定，K7游戏有权根据相关的规定做出相应的处理或者应国家有关部门要求提交进行处理。
              </div>
              <div>
                2.当K7用户申请成立战队，在公会通过批准成为正式战队后，申请人就成为该战队的队长，也即该战队的唯一正式代言人。队长必须对自己战队在公众场合的一切言行以及战队队员的言行等负责。因此，战队队员在通过本战队队员申请的时候，务必慎重。
              </div>
              <div>
                3.若本战队中的战队名称、图标、职务、战队主页以及战队成员的名称以及言行等出现任何违反规定的行为，K7游戏有权无须任何通知而对该战队停止服务，直接取消该战队，并且有权取消该战队队长和相应人员用户资格，该战队队长应承担由此引发的一切后果和责任（或因本战队队员造成连带的后果和责任），K7游戏对此不承担任何责任。
              </div>
              <div>
                4.一名用户在K7战队的每款游戏中只能参加（或创建）一个公会，加入K7战队的K7用户须遵守国家的有关法律法规以及K7游戏游戏的相关规定，为K7战队的良好环境做出自己的努力。
              </div>
              <div>
                5.在“K7战队”的游戏平台上，所有参与的战队均属于虚拟的游戏战队，所有战队的行为，均属于游戏行为，与现实生活绝无关系。“K7战队”的各战队游戏活动须遵守国家的有关法律法规以及K7游戏的相关规定，以维护K7游戏公平、文明的游戏环境，并使“K7战队”各战队在K7游戏健康发展。
              </div>
              <div>
                6.在“K7战队”发展过程中，各战队应当本着是平等互利的原则友好往来，K7游戏支之间进行各种友好活动。对于战队之间发生的各种问题，原则上由各战队自主解决，如果需要K7游戏予以帮助，可由战队的队长到在线客服或者通过其它方式请求帮助。
              </div>
              <div>
                7.本条款未涉及的问题参见国家有关法律法规，当本条款与国家法律法规冲突时，以国家法律法规为准。在本条款规定范围内，K7游戏有最终解释权。
              </div>
              <div>
                本条款由K7游戏制定，解释权、修改权归K7游戏所有。 K7游戏有权修改本条款而无须事先通知。
              </div>
            </div>
          </TabPane>

          <TabPane tab="新手指南" key="2">
            <div className="content_help">
              {/* <div className="help_title">新手指南</div> */}
              <div>1、什么是战队</div>
              <p>战队系统是为进一步促进玩家间的交流，增强游戏趣味性而推出的新型游戏功能。游戏战队由官方认可并提供战队管理功能，而一切日常组织管理都将由玩家自行管理。大家一起游戏、一起训练、一起比赛、一起发展壮大团队。</p>
              <p>双升/麻将的战场，只有团结的队伍才能取得胜利，一个兄弟倒下，还有更多的兄弟顶上来</p>
              <p>K7吹响战队兄弟连最嘹亮的集结号</p>
              <p>既然是战队我们在战场上就是一体</p>
              <p>不管输赢 是荣是辱 永远相挺到底</p>
              <p>从此有了兄弟 绝对无敌!</p>
              <p>再也没有我 只有我们</p>
              <p>我们是战场上荣辱与共的兄弟</p>
              <p>战队集结号已吹响，呼叫同城玩家，为了荣誉，为了兄弟，开始行动...</p>
              <div>2、战队有什么好处</div>
              <p>(1)、超值战队道具</p>
              <p>(2)、战队尊贵身份</p>
              <p>(3)、更多荣誉</p>
              <p>(4)、结交战友、收获友谊</p>
              <p>(5)、专门为战队打造的高端赛事</p>
              <div>3、创建战队条件</div>
              <p>
                (1)、创建队长游戏局数
                {'>'}
1局
              </p>
              <p>(2)、需要拥有1张战队卡</p>
              <p>(3)、至少需要提供1名队长和2名副队长，真实身份信息填写在申请表单里面</p>
              <p>(4)、战队队长/副队，有足够上网时间，具有一定战队管理经验和魅力</p>
              <p>(5)、具有组织线上、线下活动能力</p>
              <div>4、如何创建新战队</div>
              <p>点击战队页面首页“创建战队”填写相关信息即可创建。</p>
              <div>5、如何加入战队</div>
              <p />
              <p>第1步：选择你要加入的游戏战队</p>
              <p />
              <p>第2步：选择战队，点击“进入”战队</p>
              <p />
              <p>第3步：点击左侧“加入战队”，填写实名认证资料</p>
              <p />
              <p>第4步：加入战队QQ群，询问审核进度，结交战队朋友</p>
              <p />
              <p>第5步：等待战队队长审核</p>
              <div>6、加入战队的条件</div>
              <p>只要您热爱双升/麻将游戏，有集体荣誉感，愿意参加战队比赛和活动，即可申请加入。</p>
              <div>7、如何退出战队</div>
              <p>第1步：进入战队专区主页</p>
              <p>第2步：点击“我的战队”按钮登录</p>
              <p>第3步：再点击“我的战队”进入已经加入的战队</p>
              <p>第4步：点击左侧“退出战队”即可</p>
                （退出战队后个人威望将减少50%，并且72小时无法加入其他战队，不可逆转，请谨慎操作）
              <div>8、队员不活跃多久会被踢</div>
              <p>战队队员超过90天未登录游戏客户端则自动踢出战队。</p>
              <div>9、队长不活跃多久会被取消权限</div>
              <p>战队队长超过60天未登录客户端则自动取消队长权限，将由战队威望最高的玩家继续担任。</p>
              <div>10、战队不活跃多久会被解散</div>
              <p>连续60天战队人数不超过20人，则自动解散战队。</p>
              <div>11、如何查看战队比赛成绩</div>
              <p>进入战队专区页面主页点击‘比赛成绩’选择相应的比赛查看。</p>
              <div>12、什么是战队仓库</div>
              <p>战队仓库属于战队财产，所有战队比赛奖励将直接发放到战队仓库。</p>
              <p>队员与队长均能打开看见战队仓库里的道具。</p>
              <p>只有队长和副队长有权限对战队仓库里面的金蛋和道具支配发放。</p>
              <p>进入‘我的战队’页面后在左侧点击查看‘战队仓库’，即可查看。</p>
              <div>13、队长如何发放奖励</div>
              <p>战队仓库中的奖励只能队长和副队长有权限进行支配，队长和副队长需要进入‘战队管理’选择需要分配的道具和队员进行操作。</p>
              <div>14、员如何获取奖励</div>
              <p>队长将战队奖励分配给队员后，队员登录‘我的战队’页面，点击‘获取奖励’图标，即可获取分配的金蛋或者道具奖励。</p>
              <div>15、什么是战队捐献</div>
              <p>战队捐献是提高战队经验和提升个人威望的方法之一，每次捐献需要消耗5万个人金蛋，可以获得5点战队经验，以及5点个人威望。每人每天仅能捐献1次。</p>
              <div>16、什么是战队捐献</div>
              <p>个人威望越高战队排名就越靠前，成为精英的几率就越大，成为精英后才有机会参加战队精英赛以及其他更高级的战队赛事。</p>
              <div>17、如何获得个人威望</div>
              <p>可以通过参加战队比赛获得，以及进行战队捐献获得个人威望。</p>
              <div>18、什么是战队成就勋章</div>
              <p>战队成就是体现战队荣誉的象征，战队达到完成成就，即可获得丰富的限量成就。</p>
              <ul className="it18">
                <li>
                  <span className="it18_1">战队成就名字</span>
                  <span className="it18_2">成就说明</span>
                  <span className="it18_3">图标</span>
                </li>
                <li>
                  <span className="it18_1">元老战队</span>
                  <span className="it18_2">改版前战队等级大于1级</span>
                  <span className="it18_3"><img src={Medal1000} /></span>
                </li>
                <li>
                  <span className="it18_1">团队勋章</span>
                  <span className="it18_2">捐献次数超过5000次</span>
                  <span className="it18_3"><img src={Medal1001} /></span>
                </li>
                <li>
                  <span className="it18_1">功成名就</span>
                  <span className="it18_2">战队队员威望总和超过1000000</span>
                  <span className="it18_3"><img src={Medal1002} /></span>
                </li>
                <li>
                  <span className="it18_1">土豪</span>
                  <span className="it18_2">战队仓库金蛋超过1亿</span>
                  <span className="it18_3"><img src={Medal1003} /></span>
                </li>
                <li>
                  <span className="it18_1">紫禁之巅</span>
                  <span className="it18_2">战队等级达到9级</span>
                  <span className="it18_3"><img src={Medal1004} /></span>
                </li>
                <li>
                  <span className="it18_1">活跃之星</span>
                  <span className="it18_2">参加战队比赛达到100场</span>
                  <span className="it18_3"><img src={Medal1005} /></span>
                </li>
                <li>
                  <span className="it18_1">人山人海</span>
                  <span className="it18_2">战队人数超过100人</span>
                  <span className="it18_3"><img src={Medal1006} /></span>
                </li>
              </ul>
              <div>19、为什么要填写真实信息</div>
              <p>申请战队必须要实名制玩家，填写真实资料后即可获得系统赠送的游戏道具，填写真实信息也是为了遵守国家关于网络文明管理办法的法律法规，官方对于填写的资料资料将严格保密，不用于除认证以外的任何用途。</p>
              <div>20、如何购买战队人数扩容</div>
              <p>战队队长和副队长可以进入管理界面的“战队扩容”窗口进行扩容，目前战队每扩容1人扣除10万金蛋，增加的人数上限没有时间限制一直有效。 不同的战队等级允许扩容的人数不同，详情在战队扩容页面有详细介绍。</p>
              <div>21、战队等级具体是怎样的</div>
              <p>战队经验达到战队等级所需的战队经验时即可自动升级，具体所需经验如下</p>
              <ul className="it21">
                <li>
                  <span>Lv1到Lv2</span>
                  <span>Lv2到Lv3</span>
                  <span>Lv3到Lv4</span>
                  <span>Lv4到Lv5</span>
                  <span>Lv5到Lv6</span>
                  <span>Lv6到Lv7</span>
                  <span>Lv7到Lv8</span>
                  <span>Lv8到Lv9</span>
                  <span>Lv9后</span>
                </li>
                <li>
                  <span>1000</span>
                  <span>5000</span>
                  <span>10000</span>
                  <span>20000</span>
                  <span>40000</span>
                  <span>70000</span>
                  <span>即将开放</span>
                  <span>即将开放</span>
                  <span>即将开放</span>
                </li>
              </ul>
              <div>22、战队等级如何提升</div>
              <p>战队等级必须有用足够的经验才能提升，战队经验通过K7平台各种双升/麻将战队比赛来获得，或者通过战队队员个人捐献获得。</p>
              <div>23、战队升级人数上限明细</div>
              <ul className="it21">
                <li>
                  <span>等级1</span>
                  <span>等级2</span>
                  <span>等级3</span>
                  <span>等级4</span>
                  <span>等级5</span>
                  <span>等级6</span>
                  <span>等级7</span>
                  <span>等级8</span>
                  <span>等级9</span>
                </li>
                <li>
                  <span>68人</span>
                  <span>72人</span>
                  <span>76人</span>
                  <span>80人</span>
                  <span>84人</span>
                  <span>90人</span>
                  <span>96人</span>
                  <span>即将开放</span>
                  <span>即将开放</span>
                </li>
              </ul>
              <div>24、战队升级有哪些奖励</div>
              <p>战队等级提升后需要队长或者副队长在战队的管理后台页面点击奖励领取按钮获取战队升级奖励</p>
              <ul className="it24">
                <li>
                  <span className="it24_1">等级1</span>
                  <span className="it24_2">等级2</span>
                  <span>等级3</span>
                  <span>等级4</span>
                  <span>等级5</span>
                  <span>等级6</span>
                  <span>等级7</span>
                </li>
                <li>
                  <span className="it24_1">暂无</span>
                  <span className="it24_2">小喇叭*120</span>
                  <span>小喇叭*160</span>
                  <span>小喇叭*200</span>
                  <span>小喇叭*240</span>
                  <span>小喇叭*280</span>
                  <span>小喇叭*280</span>
                </li>
                <li>
                  <span className="it24_1" />
                  <span className="it24_2">负分清零*15</span>
                  <span>负分清零*20</span>
                  <span>负分清零*25</span>
                  <span>负分清零*30</span>
                  <span>负分清零*35</span>
                  <span>负分清零*35</span>
                </li>
                <li>
                  <span className="it24_1" />
                  <span className="it24_2">1个月VIP卡*5</span>
                  <span>1个月VIP卡*10</span>
                  <span>1个月VIP卡*15</span>
                  <span>1个月VIP卡*20</span>
                  <span>1个月VIP卡*25</span>
                  <span>1个月VIP卡*30</span>
                </li>
                <li>
                  <span className="it24_1" />
                  <span className="it24_2">互动道具*400</span>
                  <span>互动道具*480</span>
                  <span>互动道具*520</span>
                  <span>互动道具*640</span>
                  <span>互动道具*640</span>
                  <span>互动道具*680</span>
                </li>
                <li>
                  <span className="it24_1" />
                  <span className="it24_2" />
                  <span>双倍积分日卡*20</span>
                  <span>双倍积分日卡*20</span>
                  <span>双倍积分日卡*20</span>
                  <span>双倍积分日卡*20</span>
                  <span>双倍积分日卡*25</span>
                </li>
                <li>
                  <span className="it24_1" />
                  <span className="it24_2" />
                  <span />
                  <span>护身符日卡*20</span>
                  <span>护身符日卡*20</span>
                  <span>护身符日卡*20</span>
                  <span>护身符日卡*20</span>
                </li>
              </ul>
              <p>其他等级更多惊喜，等待开放！</p>
            </div>
          </TabPane>
        </Tabs>
      </div>
    );
  }
}

export default Guide;
